module.exports = require("uuid");


//////////////////
// WEBPACK FOOTER
// external "uuid"
// module id = 10
// module chunks = 0